export default {
  data() {
    return {
      rendered_pages: this.generateArray(this.total_pages),
    };
  },
  methods: {
    generateArray(totalPages) {
      const returnArray = [];
      for (let i = 1; i <= totalPages; i += 1) returnArray.push(i);
      return returnArray;
    },
  },
  watch: {
    total_pages(newValue) {
      this.rendered_pages = this.generateArray(newValue);
    },
  },
  props: ['current_page', 'total_pages', 'next', 'prev', 'set'],
  template: `<div class="pagination" v-if="total_pages > 1">
    <span class="icon shadow clickable" 
          v-on:click="prev"><i class="fa fa-arrow-left"></i></span>
    <span class="icon shadow clickable" 
          v-on:click="set(page)" 
          v-for="page in rendered_pages" 
          v-bind:class="{ active: page == current_page }">
          {{ page }}
    </span>
    <span class="icon shadow clickable" 
          v-on:click="next"><i class="fa fa-arrow-right"></i></span>
  </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Pagination.js